import {Base, Shape} from 'diagram-js/lib/model';
import {attr as svgAttr} from 'tiny-svg';
import {AUTOMATION_ID} from '@ispm-shared/modules/bpmn/diagram-element-terms';

export class ConnectionUtils {

    constructor(private elementRegistry) {
    }

    public updateSequenceFlowID(connection, source?, target?) {
        const sourceElement = source ? source : connection.source;
        const targetElement = target ? target : connection.target;
        if (sourceElement && targetElement) {
            const automationID = this.generateSequenceFlowID(sourceElement,targetElement);

            // update dom element with automationID - for automation purpose only
            let gfx = this.elementRegistry.getGraphics(connection);
            svgAttr(gfx, AUTOMATION_ID, automationID);
        }
    }

    public generateSequenceFlowID(source, target) {

        return `SequenceFlow_${source.id}*${target.id}`;
    }


}
